import { render, staticRenderFns } from "./BeastPackagesList.vue?vue&type=template&id=3b1b5c4a&scoped=true"
import script from "./BeastPackagesList.vue?vue&type=script&lang=js"
export * from "./BeastPackagesList.vue?vue&type=script&lang=js"
import style0 from "./BeastPackagesList.vue?vue&type=style&index=0&id=3b1b5c4a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1b5c4a",
  null
  
)

export default component.exports